export enum PWD_CONFIRM_TYPE {
  RESET,
  SET,
}

export const LABEL_TEXT = {
  [PWD_CONFIRM_TYPE.RESET]: '新密码',
  [PWD_CONFIRM_TYPE.SET]: '密码',
};
